import { render, staticRenderFns } from "./DisponibilidadHistorica.vue?vue&type=template&id=0372bd4d&scoped=true"
import script from "./DisponibilidadHistorica.vue?vue&type=script&lang=js"
export * from "./DisponibilidadHistorica.vue?vue&type=script&lang=js"
import style0 from "./DisponibilidadHistorica.vue?vue&type=style&index=0&id=0372bd4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0372bd4d",
  null
  
)

export default component.exports